import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoInstagram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Zm0-8c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M16.81 7.98c.06.01.13.02.19.02.26 0 .52-.11.71-.29.18-.19.29-.45.29-.71 0-.062-.008-.116-.017-.177L17.98 6.8a.636.636 0 0 0-.06-.18.556.556 0 0 0-.09-.17.62.62 0 0 0-.087-.12 1.709 1.709 0 0 1-.033-.04c-.23-.23-.57-.33-.9-.27-.07.01-.13.03-.19.06-.06.02-.12.05-.17.09-.06.04-.11.08-.16.12-.18.19-.29.45-.29.71 0 .26.11.52.29.71l.04.033a.623.623 0 0 0 .12.087c.05.04.11.07.17.09.06.03.12.05.19.06Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 22c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4H6ZM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H6Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLogoInstagram;
